import { render, staticRenderFns } from "./workReport.vue?vue&type=template&id=2141d5e6&scoped=true&"
import script from "./workReport.vue?vue&type=script&lang=js&"
export * from "./workReport.vue?vue&type=script&lang=js&"
import style0 from "./workReport.vue?vue&type=style&index=0&id=2141d5e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2141d5e6",
  null
  
)

export default component.exports